import apiClient from '../client';
import type { AttendanceRecord, AttendanceSummary, MarkAttendancePayload, StudentSession } from '@/types';

const BASE = '/admin/attendance';

export const attendanceApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: AttendanceRecord[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getSummary: (params?: {
    admission_id?: number; session_id?: number; month?: string;
    class_id?: number; class_name?: string;
    start_date?: string; end_date?: string; branch_name?: string;
  }) =>
    apiClient.get<{ data: AttendanceSummary }>(`${BASE}/summary`, { params }).then((r) => r.data.data),

  /**
   * Returns the class roster for a specific date with any existing exception
   * statuses pre-filled. Students with null status are implicitly Present.
   */
  getClassRoster: (params: { class_name: string; session_id: string | number; date: string; branch_name?: string }) =>
    apiClient.get<{ data: StudentSession[] }>(`${BASE}/class-roster`, { params }).then((r) => r.data),

  mark: (payload: MarkAttendancePayload) =>
    apiClient.post<{ data: { success: boolean; count: number } }>(`${BASE}/mark`, payload).then((r) => r.data.data),

  update: (id: number, payload: { status: string; remarks?: string }) =>
    apiClient.put<{ data: AttendanceRecord }>(`${BASE}/${id}`, payload).then((r) => r.data.data),
};

